
import Modal from './modal.style';

export default Modal;


/*
import { Modal } from 'antd';
export default Modal;

*/